import { fetchJSON } from "../helpers/fetcher"
import { ENVIRONMENT, getEndpoint } from "./endpoints"

export type TiktokToVeeqoOrdersSyncParams = {
  startDate?: string // toISONString() date format
}

export class OrdersSyncService {
  static initTiktokToVeeqoOrdersSync = async (params?: TiktokToVeeqoOrdersSyncParams) => {
    const endpointUrl = getEndpoint(ENVIRONMENT)?.tiktokToVeeqoOrdersSyncInitialize
    const stringParams: string = `startDate=${params?.startDate || ""}`

    if (endpointUrl) {
      return await fetchJSON(`${endpointUrl}?${stringParams}`, "POST")
    }
  }

  static countSyncedOrders = async () => {
    const endpointUrl = getEndpoint(ENVIRONMENT)?.countSyncedOrders

    if (endpointUrl) {
      return await fetchJSON(endpointUrl, "GET")
    }
  }

  static countCurrentSubscriptionSyncedOrders = async () => {
    const endpointUrl = getEndpoint(ENVIRONMENT)?.countCurrentSubscriptionSyncedOrders

    if (endpointUrl) {
      return await fetchJSON(endpointUrl, "GET")
    }
  }
}
